import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ShieldAlert } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import useDocumentMetadata from '../hooks/useDocumentMetadata';

export default function Forbidden() {
  const { t, lang } = useLanguage();

  const seoTitle = lang === 'da'
    ? '403 - Ingen adgang | Nordisk Psykiatri'
    : '403 - Ingen tillgång | Nordisk Psykiatri';

  const seoDesc = lang === 'da'
    ? 'Du har ikke tilladelse til at tilgå denne side.'
    : 'Du har inte behörighet att besöka denna sida.';

  useDocumentMetadata(seoTitle, seoDesc, { noIndex: true, lang });

  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center bg-sand-light px-6 py-24 text-center">
      <div className="p-4 rounded-full bg-red-50 text-red-600 mb-6 border border-red-100">
        <ShieldAlert className="h-12 w-12" />
      </div>
      <h1 className="font-display text-4xl font-light tracking-tight text-petrol-dark sm:text-5xl">
        {t('forbidden.title')}
      </h1>
      <p className="mt-6 text-base leading-7 text-text-dark/80 max-w-md">
        {t('forbidden.desc')}
      </p>
      <div className="mt-10">
        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-full bg-petrol-medium px-6 py-3 text-sm font-semibold text-white shadow-sm hover:bg-petrol-dark transition-colors gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          {t('forbidden.btn')}
        </Link>
      </div>
    </div>
  );
}
